import { defineMessages } from 'react-intl';

const messages = defineMessages({
  cancel: {
    id: 'common.button.cancel',
    defaultMessage: 'CANCEL',
  },
  request: {
    id: 'schedule.visits.confirm',
    defaultMessage: 'Yes, Request this time',
  },
  unknown: {
    id: 'schedule.visits.unknown',
    defaultMessage: 'Unknown time',
  },
  prompt: {
    id: 'schedule.visits.prompt',
    defaultMessage: 'Do you want to schedule a visit with {name} from ',
  },
  prompt1: {
    id: 'schedule.visits.prompt1',
    defaultMessage: 'Do you want to schedule a',
  },
  prompt2: {
    id: 'schedule.visits.prompt2',
    defaultMessage: ' visit with {name} from ',
  },
  promptEither: {
    id: 'schedule.visits.promptEither',
    defaultMessage: 'What type of visit would you like to schedule with {name} from ',
  },
  title: {
    id: 'schedule.visits.title',
    defaultMessage: 'Ready to Schedule?',
  },
  specialInstructions: {
    id: 'schedule.visits.specialInstructions',
    defaultMessage: 'Special Instructions for RepVisits',
  },
  virtualVisitHint: {
    id: 'schedule.visits.virtualVisitHint',
    defaultMessage: 'Virtual Visit URL:',
  },
  visitInPerson: {
    id: 'schedule.visits.visitInPerson',
    defaultMessage: 'In-person',
  },
  visitVirtual: {
    id: 'schedule.visits.visitVirtual',
    defaultMessage: 'Virtual',
  },
  error: {
    id: 'schedule.visits.notifications.error',
    defaultMessage: 'Sorry, this appointment is no longer available. Please select another appointment.',
  },
  approvedTitle: {
    id: 'schedule.visits.notifications.approvedTitle',
    defaultMessage: 'Visit Confirmed!',
  },
  approved: {
    id: 'schedule.visits.notifications.approved',
    defaultMessage: 'Your request has been automatically confirmed by the high school.',
  },
  pendingTitle: {
    id: 'schedule.visits.notifications.pendingTitle',
    defaultMessage: 'Visit requested!',
  },
  pending: {
    id: 'schedule.visits.notifications.pending',
    defaultMessage: 'You will receive an email notification when your request has been confirmed.',
  },
});

export default messages;
